// Seed data for Dashboard Irbansus — Phase 2.
// 16 Program Pengawasan 2026 with 56 sub-kegiatan total.
// Dates are ISO strings ("YYYY-MM-DD") for native <input type="date"> compatibility.

export const STATUS = {
  BELUM_MULAI: "BELUM_MULAI",
  ON_PROGRESS: "ON_PROGRESS",
  SELESAI: "SELESAI",
  TERHAMBAT: "TERHAMBAT",
};

export const STATUS_LABELS = {
  BELUM_MULAI: "Belum Mulai",
  ON_PROGRESS: "On Progress",
  SELESAI: "Selesai",
  TERHAMBAT: "Terhambat",
};

export const PRIORITAS = {
  TINGGI: "TINGGI",
  SEDANG: "SEDANG",
  RENDAH: "RENDAH",
};

export const PRIORITAS_LABELS = {
  TINGGI: "Tinggi",
  SEDANG: "Sedang",
  RENDAH: "Rendah",
};

// helper to construct a sub with sensible defaults
const sub = ({
  id,
  programId,
  nama,
  kategori = null,
  mulai = "2026-01-06",
  selesai = "2026-12-20",
  prioritas = "SEDANG",
  status = "BELUM_MULAI",
  progress = 0,
  specialType = null,
}) => ({
  id,
  programId,
  nama,
  kategori,
  targetMulai: mulai,
  targetSelesai: selesai,
  prioritas,
  status,
  progress,
  catatan: "",
  specialType,
});

// ---------- Programs ----------
export const PROGRAMS = [
  {
    id: "P01",
    kode: "P01",
    nama: "Laporan Keuangan Pemerintah Daerah Kabupaten Tasikmalaya T.A 2025",
    subKegiatan: [
      sub({
        id: "P01-01",
        programId: "P01",
        nama: "Reviu Laporan Keuangan Pemerintah Daerah T.A 2025",
        mulai: "2026-02-02",
        selesai: "2026-03-31",
        prioritas: "TINGGI",
      }),
    ],
  },
  {
    id: "P02",
    kode: "P02",
    nama: "Laporan Penyelenggaraan Pemerintahan Daerah (LPPD)",
    subKegiatan: [
      sub({
        id: "P02-01",
        programId: "P02",
        nama: "Reviu dan evaluasi penyusunan LPPD",
        mulai: "2026-02-16",
        selesai: "2026-04-24",
        prioritas: "TINGGI",
      }),
    ],
  },
  {
    id: "P03",
    kode: "P03",
    nama: "Pemantauan LHKAN",
    subKegiatan: [
      sub({
        id: "P03-01",
        programId: "P03",
        nama: "Pemantauan kepatuhan pelaporan LHKAN",
        mulai: "2026-01-12",
        selesai: "2026-11-30",
        prioritas: "SEDANG",
      }),
    ],
  },
  {
    id: "P04",
    kode: "P04",
    nama: "Tindak Lanjut atas Laporan Hasil SPI Tahun 2024",
    subKegiatan: [
      sub({
        id: "P04-01",
        programId: "P04",
        nama: "Pemantauan tindak lanjut LHP SPI 2024",
        mulai: "2026-01-12",
        selesai: "2026-10-30",
        prioritas: "SEDANG",
      }),
    ],
  },
  {
    id: "P05",
    kode: "P05",
    nama: "Evaluasi Internal Reformasi Birokrasi",
    subKegiatan: [
      sub({
        id: "P05-01",
        programId: "P05",
        nama: "Evaluasi Internal On Going Triwulan ke-4 2025",
        mulai: "2026-01-06",
        selesai: "2026-02-06",
        prioritas: "TINGGI",
      }),
      sub({
        id: "P05-02",
        programId: "P05",
        nama: "Evaluasi Internal Ex-Ante 2026",
        mulai: "2026-02-09",
        selesai: "2026-03-13",
        prioritas: "TINGGI",
      }),
      sub({
        id: "P05-03",
        programId: "P05",
        nama: "Evaluasi Internal On Going Triwulan ke-1 2026",
        mulai: "2026-04-01",
        selesai: "2026-05-08",
      }),
      sub({
        id: "P05-04",
        programId: "P05",
        nama: "Evaluasi Internal On Going Triwulan ke-2 2026",
        mulai: "2026-07-01",
        selesai: "2026-08-07",
      }),
      sub({
        id: "P05-05",
        programId: "P05",
        nama: "Evaluasi Internal On Going Triwulan ke-3 2026",
        mulai: "2026-10-01",
        selesai: "2026-11-06",
      }),
    ],
  },
  {
    id: "P06",
    kode: "P06",
    nama: "Zona Integritas",
    subKegiatan: [
      sub({ id: "P06-01", programId: "P06", nama: "Pembangunan Zona Integritas menuju WBK", mulai: "2026-02-02", selesai: "2026-06-30", prioritas: "TINGGI" }),
      sub({ id: "P06-02", programId: "P06", nama: "Penilaian Mandiri Pembangunan Zona Integritas", mulai: "2026-07-01", selesai: "2026-08-29" }),
      sub({ id: "P06-03", programId: "P06", nama: "Evaluasi dan tindak lanjut hasil penilaian ZI", mulai: "2026-09-01", selesai: "2026-11-30" }),
    ],
  },
  {
    id: "P07",
    kode: "P07",
    nama: "Peningkatan Kapabilitas APIP",
    subKegiatan: [
      sub({ id: "P07-01", programId: "P07", nama: "Penyusunan peta strategi kapabilitas APIP", mulai: "2026-01-12", selesai: "2026-02-27" }),
      sub({ id: "P07-02", programId: "P07", nama: "Pelaksanaan self assessment Level 3 IACM", mulai: "2026-03-02", selesai: "2026-05-29", prioritas: "TINGGI" }),
      sub({ id: "P07-03", programId: "P07", nama: "Penyusunan rencana tindak peningkatan kapabilitas", mulai: "2026-06-01", selesai: "2026-07-31" }),
      sub({ id: "P07-04", programId: "P07", nama: "Pelatihan dan pengembangan kompetensi auditor", mulai: "2026-04-01", selesai: "2026-10-31" }),
      sub({ id: "P07-05", programId: "P07", nama: "Reviu infrastruktur audit (SOP, PKPT)", mulai: "2026-05-04", selesai: "2026-08-28" }),
      sub({ id: "P07-06", programId: "P07", nama: "Evaluasi capaian Level 3 IACM", mulai: "2026-11-02", selesai: "2026-12-18" }),
    ],
  },
  {
    id: "P08",
    kode: "P08",
    nama: "Sistem Pengendalian Intern Pemerintah (SPIP)",
    subKegiatan: [
      sub({ id: "P08-01", programId: "P08", nama: "Pemetaan risiko strategis pemerintah daerah", mulai: "2026-01-05", selesai: "2026-02-27", prioritas: "TINGGI" }),
      sub({ id: "P08-02", programId: "P08", nama: "Penilaian mandiri maturitas SPIP", mulai: "2026-03-02", selesai: "2026-04-30", prioritas: "TINGGI" }),
      sub({ id: "P08-03", programId: "P08", nama: "Penyusunan RTP (Rencana Tindak Pengendalian)", mulai: "2026-05-04", selesai: "2026-06-30" }),
      sub({ id: "P08-04", programId: "P08", nama: "Sosialisasi SPIP ke OPD", mulai: "2026-03-02", selesai: "2026-05-29" }),
      sub({ id: "P08-05", programId: "P08", nama: "Asistensi implementasi SPIP pada OPD pilot", mulai: "2026-04-01", selesai: "2026-09-30" }),
      sub({ id: "P08-06", programId: "P08", nama: "Reviu penyelenggaraan SPIP tingkat OPD", mulai: "2026-07-01", selesai: "2026-09-30" }),
      sub({ id: "P08-07", programId: "P08", nama: "Penguatan lingkungan pengendalian", mulai: "2026-02-02", selesai: "2026-08-31" }),
      sub({ id: "P08-08", programId: "P08", nama: "Pemantauan berkelanjutan efektivitas pengendalian", mulai: "2026-01-05", selesai: "2026-12-18" }),
      sub({ id: "P08-09", programId: "P08", nama: "Evaluasi terpisah pengendalian intern", mulai: "2026-10-01", selesai: "2026-11-30" }),
      sub({ id: "P08-10", programId: "P08", nama: "Pelaporan dan komunikasi hasil SPIP", mulai: "2026-11-02", selesai: "2026-12-11" }),
      sub({ id: "P08-11", programId: "P08", nama: "Tindak lanjut rekomendasi maturitas SPIP", mulai: "2026-11-02", selesai: "2026-12-18" }),
    ],
  },
  {
    id: "P09",
    kode: "P09",
    nama: "Capaian Aksi Koordinasi Supervisi Pencegahan Korupsi",
    subKegiatan: [
      sub({ id: "P09-01", programId: "P09", nama: "Aksi 1 — Perencanaan & penganggaran daerah", mulai: "2026-01-05", selesai: "2026-03-31", prioritas: "TINGGI" }),
      sub({ id: "P09-02", programId: "P09", nama: "Aksi 2 — Pengadaan barang dan jasa", mulai: "2026-02-02", selesai: "2026-05-29", prioritas: "TINGGI" }),
      sub({ id: "P09-03", programId: "P09", nama: "Aksi 3 — Perizinan dan PTSP", mulai: "2026-03-02", selesai: "2026-06-30" }),
      sub({ id: "P09-04", programId: "P09", nama: "Aksi 4 — Pengawasan APIP", mulai: "2026-01-05", selesai: "2026-08-31" }),
      sub({ id: "P09-05", programId: "P09", nama: "Aksi 5 — Manajemen ASN", mulai: "2026-04-01", selesai: "2026-07-31" }),
      sub({ id: "P09-06", programId: "P09", nama: "Aksi 6 — Optimalisasi pendapatan daerah", mulai: "2026-03-02", selesai: "2026-09-30" }),
      sub({ id: "P09-07", programId: "P09", nama: "Aksi 7 — Manajemen aset daerah", mulai: "2026-04-01", selesai: "2026-09-30" }),
      sub({ id: "P09-08", programId: "P09", nama: "Aksi 8 — Tata kelola desa", mulai: "2026-05-04", selesai: "2026-10-30" }),
      sub({ id: "P09-09", programId: "P09", nama: "Aksi 9 — Integritas layanan publik", mulai: "2026-06-01", selesai: "2026-11-30" }),
      sub({ id: "P09-10", programId: "P09", nama: "Aksi 10 — MCP (Monitoring Centre for Prevention)", mulai: "2026-01-05", selesai: "2026-12-18", prioritas: "TINGGI" }),
      sub({ id: "P09-11", programId: "P09", nama: "Aksi 11 — Evaluasi capaian Korsupgah", mulai: "2026-11-02", selesai: "2026-12-18" }),
    ],
  },
  {
    id: "P10",
    kode: "P10",
    nama: "Reviu Kecukupan Anggaran dan SDM Irbansus",
    subKegiatan: [
      sub({ id: "P10-01", programId: "P10", nama: "Analisis kebutuhan anggaran Irbansus", mulai: "2026-02-02", selesai: "2026-03-31", prioritas: "TINGGI" }),
      sub({ id: "P10-02", programId: "P10", nama: "Analisis kebutuhan SDM Irbansus", mulai: "2026-02-02", selesai: "2026-04-30", prioritas: "TINGGI" }),
      sub({ id: "P10-03", programId: "P10", nama: "Penyusunan rekomendasi penguatan kapasitas", mulai: "2026-05-04", selesai: "2026-06-30" }),
    ],
  },
  {
    id: "P11",
    kode: "P11",
    nama: "Pengawasan dengan Tujuan Tertentu",
    subKegiatan: [
      sub({ id: "P11-01", programId: "P11", kategori: "11a", nama: "Reviu pelaksanaan perjanjian kerjasama APIP", mulai: "2026-02-02", selesai: "2026-06-30" }),
      sub({ id: "P11-02", programId: "P11", kategori: "11a", nama: "Evaluasi efektivitas perjanjian kerjasama APIP", mulai: "2026-07-01", selesai: "2026-11-30" }),
      sub({ id: "P11-03", programId: "P11", kategori: "11b", nama: "Telaah awal pengaduan masyarakat berindikasi korupsi", mulai: "2026-01-05", selesai: "2026-12-18", prioritas: "TINGGI" }),
      sub({ id: "P11-04", programId: "P11", kategori: "11b", nama: "Pemeriksaan lanjutan pengaduan masyarakat", mulai: "2026-02-02", selesai: "2026-12-18", prioritas: "TINGGI" }),
      sub({
        id: "P11-05",
        programId: "P11",
        kategori: "11c",
        nama: "Tindak Lanjut Pemeriksaan Khusus / Audit Investigasi",
        mulai: "2026-01-05",
        selesai: "2026-12-18",
        prioritas: "TINGGI",
        specialType: "AUDIT_INVESTIGASI",
      }),
      sub({ id: "P11-06", programId: "P11", kategori: "11d", nama: "Monitoring tindak lanjut hasil pengaduan masyarakat", mulai: "2026-01-05", selesai: "2026-12-18" }),
      sub({ id: "P11-07", programId: "P11", kategori: "11d", nama: "Evaluasi tindak lanjut hasil Dumas oleh OPD", mulai: "2026-04-01", selesai: "2026-11-30" }),
    ],
  },
  {
    id: "P12",
    kode: "P12",
    nama: "Penanganan Penyelesaian Kerugian Negara/Daerah",
    subKegiatan: [
      sub({ id: "P12-01", programId: "P12", nama: "Perhitungan kerugian keuangan negara/daerah", mulai: "2026-01-05", selesai: "2026-05-29", prioritas: "TINGGI" }),
      sub({ id: "P12-02", programId: "P12", nama: "Pemberian keterangan ahli", mulai: "2026-06-01", selesai: "2026-12-18", prioritas: "TINGGI" }),
    ],
  },
  {
    id: "P13",
    kode: "P13",
    nama: "Penyusunan PPBR 2027",
    subKegiatan: [
      sub({ id: "P13-01", programId: "P13", nama: "Penyusunan Program Pengawasan Berbasis Risiko (PPBR) 2027", mulai: "2026-08-03", selesai: "2026-11-30", prioritas: "TINGGI" }),
    ],
  },
  {
    id: "P14",
    kode: "P14",
    nama: "Peraturan Bupati tentang Pengelolaan Konflik Kepentingan",
    subKegiatan: [
      sub({ id: "P14-01", programId: "P14", nama: "Penyusunan draft Perbup pengelolaan konflik kepentingan", mulai: "2026-03-02", selesai: "2026-09-30" }),
    ],
  },
  {
    id: "P15",
    kode: "P15",
    nama: "Evaluasi Peraturan Bupati tentang Pengaduan Masyarakat",
    subKegiatan: [
      sub({ id: "P15-01", programId: "P15", nama: "Evaluasi dan revisi Perbup Pengaduan Masyarakat", mulai: "2026-02-02", selesai: "2026-08-31" }),
    ],
  },
  {
    id: "P16",
    kode: "P16",
    nama: "Penyusunan Perjanjian Kerjasama APIP dan APH",
    subKegiatan: [
      sub({ id: "P16-01", programId: "P16", nama: "Penyusunan dan penandatanganan PKS APIP-APH", mulai: "2026-03-02", selesai: "2026-07-31", prioritas: "TINGGI" }),
    ],
  },
];

export const SEED_VERSION = 2;
